import axios from 'axios';
import config from './config';


const API_BASE_URL = config.API_BASE_URL; // URL de base des API


export const fetchData = async (endpoint) => {
  try {
       
    const response = await axios.get(`${API_BASE_URL}/${endpoint}` , {
    });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des données:', error);
    throw error;
  }
};